module.exports = __webpack_public_path__ + "static/steve-273b50e9ab3e9547f6db263b5748847d.jpg";